// services/notificationService/mutations.ts - services/notificationService.ts split (sub-module mutations)

import type {Notification} from '../../types';
import { supabase, getSessionUser } from '../../supabase';


// Mark single notification as read
export async function markAsRead(id: string) {
  try {
    const { error } = await supabase
      .from('notifications')
      .update({ is_read: true, read_at: new Date().toISOString() })
      .eq('id', id);

    if (error) {
      console.error('Error marking as read:', error);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error in markAsRead:', error);
    return false;
  }
}



// Mark all notifications as read
export async function markAllAsRead() {
  try {
    const user = await getSessionUser();
    if (!user) return false;

    const { error } = await supabase
      .from('notifications')
      .update({ is_read: true, read_at: new Date().toISOString() })
      .eq('user_id', user.id)
      .eq('is_deleted', false);

    if (error) {
      console.error('Error marking all as read:', error);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error in markAllAsRead:', error);
    return false;
  }
}



// Delete (soft delete) a notification
export async function deleteNotification(id: string) {
  try {
    const { error } = await supabase
      .from('notifications')
      .update({ is_deleted: true })
      .eq('id', id);

    if (error) {
      console.error('Error deleting notification:', error);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error in deleteNotification:', error);
    return false;
  }
}



// Filter notifications by user role (client-side filtering)
export function filterNotificationsByRole(notifications: Notification[], role: string) {
  // All notifications are already filtered by user_id on server
  // This is for additional role-based filtering if needed
  return notifications;
}
